export interface RadioButtonOption<T = unknown> {
  label: string;
  value: T;
}
